// Bezug → Mühle, under the grinder's name and scale: what Claude found out about the grinder (the cloud looks it up with
// the account's key, Anthropic web search, sources as links). Moved here from the Claude card (Dominik, 19.10.2026: "die
// muehle sollte auch nicht hier sein. Das ist nicht richtig platziert."). Board "Mühle": a card "Claude (i)" with one
// sentence and "Mühle nachschlagen"; once looked up, what Claude knows behind one row. Without a key nothing shows
// (Dominik 22.10.2026). Decisions in src/ai/view.ts (grinderInfoView).
import { useEffect, useState } from 'react';
import { grinderInfoView } from '../../ai/view.js';
import { Button, Card, CardHeader, Disclosure } from '../components/index.js';
import { useMachine } from '../machine-context.js';
import { useAssistant } from './use-assistant.js';

export function GrinderInfo() {
  const { ctx, machineId } = useMachine();
  const { assistant, view } = useAssistant();
  const [open, setOpen] = useState(false);
  const name = String(ctx.value('brew.grinder') ?? '').trim();
  const hasKey = !!view.account?.key;
  useEffect(() => {
    if (hasKey && name) void assistant.loadGrinder(machineId, name);
  }, [assistant, machineId, name, hasKey]);
  const g = grinderInfoView(ctx.lang, name, view, assistant.grinder(machineId));
  if (!g) return null;
  const lookUp = (again: boolean) => void assistant.lookUpGrinder(machineId, again, ctx.lang);
  return (
    <Card className="tab-card ai-grinder" data-testid="grinder-claude">
      <CardHeader
        title={ctx.tr('aiGrinderTitle')}
        info={{ text: ctx.tr('aiGrinderInfo'), label: ctx.tr('infoShow'), testId: 'grinder-claude-help' }}
      />
      {!g.info && !g.busy && <p className="ai-text">{ctx.tr('aiGrinderPitch', { n: name })}</p>}
      {g.info || g.busy ? (
        <Disclosure
          open={open && !!g.info}
          disabled={!g.info}
          onClick={() => setOpen(!open)}
          data-testid="grinder-claude-open"
        >
          {g.title}
        </Disclosure>
      ) : null}
      {open && g.info && (
        <>
          <p className="ai-text" data-testid="grinder-claude-info">
            {g.info}
          </p>
          {g.sources.length > 0 && (
            <p className="hint ai-sources">
              {ctx.tr('aiSources')}:{' '}
              {g.sources.map((s, i) => (
                <span key={s.href}>
                  {i > 0 && ' · '}
                  <a href={s.href} target="_blank" rel="noopener noreferrer">
                    {s.host}
                  </a>
                </span>
              ))}
            </p>
          )}
        </>
      )}
      {g.action &&
        (g.action.again ? (
          open && (
            <button
              type="button"
              className="link-btn"
              onClick={() => lookUp(true)}
              data-testid="grinder-claude-again"
            >
              {g.action.label}
            </button>
          )
        ) : (
          <Button
            variant="secondary"
            block
            icon="sparkle"
            onClick={() => lookUp(false)}
            data-testid="grinder-claude-lookup"
          >
            {g.action.label}
          </Button>
        ))}
      {g.error && (
        <p className="field-error" role="alert">
          {g.error}
        </p>
      )}
    </Card>
  );
}
